import { cloneDeep } from 'lodash';
const SET_BRAINTREE_FAILURE = 'SET_BRAINTREE_FAILURE';
const CLEAR_BRAINTREE_FAILURE = 'CLEAR_BRAINTREE_FAILURE';

const initialState = null;

export default function reducer(state = cloneDeep(initialState), action) {
	switch (action.type) {
		case SET_BRAINTREE_FAILURE:
			return action.payload;
		case CLEAR_BRAINTREE_FAILURE:
			return null;
		default:
			return state;
	}
}

export function setBraintreeFailure(msg){
	return {
		type: SET_BRAINTREE_FAILURE,
		payload: msg
	}
}

export function clearBraintreeFailure(){
	return { type: CLEAR_BRAINTREE_FAILURE };
}



// WEBPACK FOOTER //
// ./src/modules/braintree_failure.js